// ===========================================
// SCHEMA: CrearEvento
// ===========================================
// Schema Zod for create/edit event form

import { z } from 'zod'

export const crearEventoSchema = z.object({
  titulo: z.string().min(1, 'El título es requerido'),
  descripcion: z.string().nullable().optional(),
  tipo: z.enum(['audiencia', 'reunion', 'recordatorio', 'cita', 'otro'], {
    message: 'El tipo es requerido',
  }),
  fecha_inicio: z.string().min(1, 'La fecha es requerida'),
  hora_inicio: z.string().nullable().optional(),
  fecha_fin: z.string().nullable().optional(),
  hora_fin: z.string().nullable().optional(),
  todo_el_dia: z.boolean(),
  estado: z.enum(['pendiente', 'confirmado', 'cancelado', 'completado']).optional(),
  color: z.string().nullable().optional(),
  ubicacion: z.string().nullable().optional(),
  notas: z.string().nullable().optional(),
  // ORR-227: emails de los invitados a la reunión. Van a `participantes text[]`,
  // que ya existe en la tabla.
  participantes: z.array(z.email('Email inválido')).nullable().optional(),
  // ORR-383: la serie. Se guarda como RRULE en `regla_recurrencia`, que ya existe en la tabla.
  // El día de la semana y el del mes salen de `fecha_inicio`, no se eligen aparte.
  // Opcional y no `.default()`: quien arma un evento sin pensar en series tiene que seguir
  // validando, y la ausencia ES "no se repite". `.default()` no sirve acá — deja el tipo de
  // ENTRADA opcional y el de salida requerido, y TanStack Form exige que coincidan.
  repeticion: z.enum(['ninguna', 'semanal', 'mensual']).optional(),
  repetir_hasta: z.string().nullable().optional(),
})

/**
 * Valida un email suelto antes de sumarlo a la lista de invitados.
 *
 * El `.trim()` va antes del `pipe`, no encadenado después de `z.email()`: en Zod v4 el orden es el
 * de escritura, así que `z.email().trim()` validaría con los espacios puestos y rechazaría un mail
 * pegado desde otro lado.
 */
export const emailInvitadoSchema = z.string().trim().pipe(z.email('Email inválido'))

export type CrearEventoFormValues = z.infer<typeof crearEventoSchema>
